import React, { useState, useEffect } from 'react';

import { makeRelativeTimeString } from './util.js';
import { endpoints } from './endpoints.js';
import { fetchWithJWT } from './requests.js';

function Listeners() {
  const [listeners, setListeners] = useState(null);
  const [expanded, setExpanded] = useState({});

  useEffect(() => {
    fetchWithJWT(endpoints.getListeners, "GET", null,
      (data) => {
        setListeners(Array.isArray(data.Result) ? data.Result : []);
      },
      console.log,
    )
  }, []);

  const toggleExpanded = (id) => {
    setExpanded({...expanded, [id]: !expanded[id]});
  }

  const expandAll = () => {
    if (listeners === null) {
      return;
    }

    let all = {};
    listeners.forEach((listener) => {
      all[listener.ID] = true;
    });
    setExpanded(all);
  }

  const collapseAll = () => {
    setExpanded({});
  }

  function makeTelemetryTable(containers) {
    if (containers.length === 0) {
      return <p>No container telemetry.</p>;
    }

    return (
      <table className="table is-fullwidth is-narrow">
        <thead>
          <tr>
            <th>Container</th>
            <th>Ports</th>
            <th>Status</th>
            <th>Created</th>
          </tr>
        </thead>
        <tbody>
          {containers.map((container, index) => (
            <tr key={index}>
              <td>{Array.isArray(container.Names) ? container.Names.join(", ") : ""}</td>
              <td>{Array.isArray(container.Ports) ? container.Ports.join(", ") : ""}</td>
              <td>{container.Status}</td>
              <td>{makeRelativeTimeString(container.Created, true)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  function makeRows(listener) {
    const containers = Array.isArray(listener.ContainerTelemetry) ? listener.ContainerTelemetry : [];
    const isExpanded = !!expanded[listener.ID];

    return (
      <React.Fragment key={listener.ID}>
        <tr>
          <td>{listener.ID}</td>
          <td className="honey-text-font-monospace">{listener.HostIP}</td>
          <td className="has-text-right">
            <button
              className="button is-small honey-button"
              onClick={() => {toggleExpanded(listener.ID)}}
              aria-expanded={isExpanded}
            >
              <span className="icon is-small">
                <i className={`fas ${isExpanded ? "fa-chevron-down" : "fa-chevron-right"}`}></i>
              </span>
            </button>
          </td>
        </tr>
        {isExpanded ? (
          <tr>
            <td colSpan="3">
              {makeTelemetryTable(containers)}
            </td>
          </tr>
        ) : null}
      </React.Fragment>
    );
  }

  return (
    <div className="container block">
      <div className="level">
        <div className="level-left">
          <div className="level-item">
            <h2 className="title has-text-weight is-4 honey-text-font-family honey-text-common">
              Listeners
            </h2>
          </div>
        </div>
        <div className="level-right">
          <div className="level-item">
            <button className="button honey-button" onClick={expandAll}>
              Expand All
            </button>
          </div>
          <div className="level-item">
            <button className="button honey-button" onClick={collapseAll}>
              Collapse All
            </button>
          </div>
        </div>
      </div>
      {listeners === null ? null : (
        <div className="table-container honey-round-border honey-table-overflow">
          <table className="table is-fullwidth">
            <thead>
              <tr>
                <th>ID</th>
                <th>Host IP</th>
                <th className="has-text-right">Telemetry</th>
              </tr>
            </thead>
            <tbody>
              {listeners.map(makeRows)}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Listeners;
